<div class="inner-events-table utils-bar" [ngClass]="{'table-min': link_only}">
  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" [pageSize]="page_size"
    (page)="loading_next=true"
    showFirstLastButtons #eventPaginator="matPaginator">
  </mat-paginator>
</div>

<table [dataSource]="eventDataSource" [appLdsRoller]="loading_next"
  class="table inner-component-events-table inner-events-table" [ngClass]="{'table-min': link_only}"
  mat-table matSort>
  @for (col of event_columns; track col) {
    @if (col==='Unlink') {
      <ng-container matColumnDef="{{col}}">
        <th *matHeaderCellDef mat-header-cell [disabled]>
        <!-- {{col | upperfirst | removeUnderscore}}</th> -->
        <td *matCellDef="let event;" mat-cell class="lock-indicator">
          @if (locked_dict[event.id]?.component) {
            <i class="fa fa-lock lock-indicator-icon"></i>
          }
          <button mat-button (click)="openAuditModal($event, event)" class="table-button relationship-info-button"
            [matTooltip]="'View relationship audit information'"
            matTooltipPosition="above">
            <i class="fas fa-info-circle"></i>
          </button>
          <button mat-button class="unlink-event-btn table-button" (click)="unlinkEvent(event)"
            [matTooltip]="!canUnlink(event.id)? 'Unlink not allowed' : 'Remove this event from ' + component?.attributes?.name"
            matTooltipPosition="above"
            [disabled]="!canUnlink(event.id)">
            <i class="fas fa-unlink"></i>
          </button>
        </td>
      </ng-container>
    }
    <!--Comment, Start, End-->
    @if (extra_cols.includes(col)) {
      <ng-container matColumnDef="{{col}}">
        <th *matHeaderCellDef mat-header-cell [resizable]="format_dict?.[col]"
          (resizable)="resizeColumn(col, $event)" [constrainWidth]="config.constrain_width"
          mat-sort-header>{{selected_cols_event_dict[col]?.title || col | upperfirst | removeUnderscore}}
        </th>
        <td *matCellDef="let event;" mat-cell style="text-align: left;"
          [class.disabled]="selected_cols_event_dict[col]?.disabled" [ngStyle]="format_dict?.[col]?.style || null">
          @if (locked_dict?.[event.id]?.[col]) {
            <i class="fa fa-lock lock-indicator-icon"></i>
          }
          @if (col==='comment') {
            <div class="row center" style="height:100%;">
              <input #cp_input (change)="saveEvent(event, col, $event)"
                [(ngModel)]="event.attributes.comment"
                [matTooltipDisabled]="!customEventsService.event_state[event.id]"
                [matTooltip]="customEventsService.event_state[event.id]? customEventsService.event_state[event.id].message : ''"
                [ngClass]="customEventsService.event_state[event.id]? customEventsService.event_state[event.id].state: ''"
                [disabled]="selected_cols_event_dict[col]?.disabled"
                tabindex="1"/>
            </div>
          }
          @if (col==='start' || col==='end') {
            <div class="row center disabled">
              {{event.attributes[col.toLowerCase()] | stringDate}}
            </div>
          }
        </td>
      </ng-container>
    }
    <!--Event Constant Properties-->
    @if (event_properties.includes(col) && !extra_cols.includes(col)) {
      <ng-container matColumnDef="{{col}}">
        <th *matHeaderCellDef mat-header-cell [resizable]="format_dict?.[col]"
          (resizable)="resizeColumn(col, $event)" [constrainWidth]="config.constrain_width"
          >{{selected_cols_event_dict[col]?.title || cp_dict[col]?.attributes.name || col | upperfirst | removeUnderscore}}
        </th>
        <td *matCellDef="let event" class="input-cell" mat-cell style="text-align: left;"
          [matTooltipDisabled]="!customEventsService.event_state[event.id + col]"
          [matTooltip]="customEventsService.event_state[event.id + col]? customEventsService.event_state[event.id + col].message : ''"
          [ngClass]="customEventsService.event_state[event.id + col]? customEventsService.event_state[event.id + col].state: ''"
          [class.disabled]="selected_cols_event_dict[col]?.disabled || cp_dict[col]?.attributes.is_calculation"
          [ngStyle]="format_dict?.[col]?.style || null">
          @if (event_constants?.[event.id]?.hasOwnProperty(col)) {
            <generic-constant-field [constant]="event_constants[event.id][col]"
              [constant_property]="cp_dict[col]"
              (constant_changed)="event_constants[event.id][col].value = $event;"
              (change_complete)="saveConstant(event, col, $event)"
              [disabled]="cp_dict[col]?.attributes.is_calculation || selected_cols_event_dict[col]?.disabled"
              [formats]="selected_cols_event_dict[col]?.format"
              class="constant-field"
            ></generic-constant-field>
          }
        </td>
      </ng-container>
    }
  }
  <tr *matHeaderRowDef="event_columns; sticky: true" mat-header-row></tr>
  <tr *matRowDef="let event; columns: event_columns;" mat-row></tr>
</table>

<div style="position: relative;" class="inner-events-table-status">{{event_status}}</div>
